<template>
  <!-- <div>
    <div v-if="isFilterApplied" class="d-flex justify-content-end mb-3">
      <a href="javascript:;" class="btn btn-secondary w-60 display-6"  @click="handleClearFilters"> Clear Filters </a>
    </div>
  </div> -->
  <form @submit.prevent="handleFilters">
  <div class="row filter-row mb-3">

    <div class="col-sm-6 col-md-2">
      <div class="input-block mt-1 mb-0">
        <div class="filter-label-row">
          <label class="filter-label">Employment Status</label>
          <i v-if="filters.employee_status" @click="handleClearOneFilter('employee_status')" class="fa-solid fa-x filter-clear-icon"></i>
        </div>
        <vue-select :style="`${ filters.employee_status && 'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'}`" :options="employmentStatuses" placeholder="Select Status" id="design" v-model="filters.employee_status" :disabled="employmentStatusesLoading" @mouseenter.once="fetchEmploymentStatuses" />
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mt-1 mb-0">
        <div class="filter-label-row">
          <label class="filter-label">Division</label>
          <i v-if="filters.division" @click="handleClearOneFilter('division')" class="fa-solid fa-x filter-clear-icon"></i>
        </div>
        <vue-select :style="`${ filters.division && 'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'}`" :options="divisions" v-model="filters.division"  placeholder="Select Division" id="design3" :disabled="divisionsLoading" @mouseenter.once="fetchDivisions" />
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mt-1 mb-0">
        <div class="filter-label-row">
          <label class="filter-label">Department</label>
          <i v-if="filters.department" @click="handleClearOneFilter('department')" class="fa-solid fa-x filter-clear-icon"></i>
        </div>
        <vue-select :style="`${ filters.department && 'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'}`" :options="departments" v-model="filters.department" placeholder="Select Department" id="design2" :disabled="departmentsLoading" @mouseenter.once="fetchDepartments"  />
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mt-1 mb-0 text-truncate">
        <div class="filter-label-row">
          <label class="filter-label">Campaign</label>
          <i v-if="filters.campaign" @click="handleClearOneFilter('campaign')" class="fa-solid fa-x filter-clear-icon"></i>
        </div>
        <vue-select :style="`${ filters.campaign && 'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'}`" :options="campaigns" v-model="filters.campaign" placeholder="Select Campaign" id="design4" :disabled="campaignsLoading" @mouseenter.once="fetchCampaigns" />
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mt-1 mb-0">
        <div class="filter-label-row">
          <label class="filter-label">Section</label>
          <i v-if="filters.section" @click="handleClearOneFilter('section')" class="fa-solid fa-x filter-clear-icon"></i>
        </div>
        <vue-select :style="`${ filters.section && 'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'}`" :options="sections" v-model="filters.section" placeholder="Select Section" id="design5" :disabled="sectionsLoading" @mouseenter.once="fetchSections" />
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mt-1 mb-0">
        <div class="filter-label-row">
          <label class="filter-label">Designation</label>
          <i v-if="filters.designation" @click="handleClearOneFilter('designation')" class="fa-solid fa-x filter-clear-icon"></i>
        </div>
        <vue-select :style="`${ filters.designation && 'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'}`"  :options="designations" v-model="filters.designation" placeholder="Select Designation" id="design6" :disabled="designationsLoading" @mouseenter.once="fetchDesignations" />
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mt-1 mb-0 text-truncate">
        <div class="filter-label-row">
          <label class="filter-label">Project</label>
          <i v-if="filters.project" @click="handleClearOneFilter('project')" class="fa-solid fa-x filter-clear-icon"></i>
        </div>
        <vue-select :style="`${ filters.project && 'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'}`" :options="projects" v-model="filters.project" placeholder="Select Project" id="design7" :disabled="projectsLoading" @mouseenter.once="fetchProjects" />
      </div>
    </div>

    <div class="col-sm-6 col-md-2">
      <div class="input-block mt-1 mb-0">
        <div class="filter-label-row">
          <label class="filter-label">Employee WFH Status</label>
          <i v-if="filters.employee_wfh" @click="handleClearOneFilter('employee_wfh')" class="fa-solid fa-x filter-clear-icon"></i>
        </div>
        <vue-select :style="`${ filters.employee_wfh && 'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'}`" :options="employmentWfhStatuses" placeholder="Select Status" id="design8" v-model="filters.employee_wfh" />
      </div>
    </div>

    <div class="col-sm-6 col-md-2">
      <div class="input-block mt-1 mb-0">
        <label class="filter-label">Employee ID</label>
        <input
          type="text"
          :style="`${ filters.employee_id && 'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'}`"
          class="form-control filter-input"
          v-model="filters.employee_id"
        />
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mt-1 mb-0">
        <label class="filter-label">Employee Name</label>
        <input
          type="text"
          class="form-control filter-input"
          :style="`${ filters.employee_name && 'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'}`"
          v-model="filters.employee_name"
        />
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mt-1 mb-0">
        <label class="filter-label">First Name</label>
        <input
          type="text"
          class="form-control filter-input"
          :style="`${ filters.first_name && 'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'}`"
          v-model="filters.first_name"
        />
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mt-1 mb-0">
        <label class="filter-label">Last Name</label>
        <input
          type="text"
          class="form-control filter-input"
          :style="`${ filters.last_name && 'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'}`"
          v-model="filters.last_name"
        />
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mt-1 mb-0">
        <label class="filter-label">CNIC</label>
        <input
          type="text"
          class="form-control filter-input"
          :style="`${ filters.employee_cnic && 'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'}`"
          v-model="filters.employee_cnic"
        />
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mt-1 mb-0">
        <label class="filter-label">Contact #</label>
        <input
          type="text"
          class="form-control filter-input"
          :style="`${ filters.employee_contact && 'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'}`"
          v-model="filters.employee_contact"
          @input="filters.employee_contact = filters.employee_contact.replace(/[^0-9-+ ]/g, '')"
        />
      </div>
    </div>
     <div class="col-sm-6 col-md-2">
      <div class="input-block mt-1 mb-0">
        <label class="filter-label">Email</label>
        <input
          type="text"
          class="form-control filter-input"
          :style="`${ filters.employee_email && 'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'}`"
          v-model="filters.employee_email"
        />
      </div>
    </div>
     <div class="col-sm-6 col-md-2">
      <div class="input-block mt-1 mb-0">
        <label class="filter-label">Pseudo Name</label>
        <input
          type="text"
          class="form-control filter-input"
          :style="`${ filters.pseudo && 'border-bottom: var(--primary-color) 2px solid; border-radius: 6px;'}`"
          v-model="filters.pseudo"
        />
      </div>
    </div>
    <!-- <div class="col-md-1">
    </div> -->
    <div class="d-flex align-items-end col-sm-6 col-md-3 gap-2 mt-1">
      <button type="submit" class="btn btn-filter" @click.prevent="handleFilters"> <i class="fa-solid fa-filter me-1"></i> Search </button>
      <button type="button" class="btn btn-reset" @click.prevent="resetAllFilters"> <i class="fa-solid fa-rotate-left me-1"></i> Reset </button>
    </div>
    
  </div>
</form>
</template>

<script>
import EmploymentStatusService from '@/services/EmploymentStatusService';
import DepartmentService from '@/services/DepartmentService';
import DivisionService from '@/services/DivisionService';
import CampaignService from '@/services/CampaignService';
import SectionService from '@/services/SectionService';
import DesignationService from '@/services/DesignationService';
import EmployeeProjectService from '@/services/EmployeeProjectService';

export default {
  data() {
    return {
      select2: null,
      Company: ["Select Company", "Global Technologies", "Delta Infotech"],
      filters:{
      employee_id: "",
      employee_name: "",
      first_name: "",
      last_name: "",
      employee_cnic:"",
      employee_contact:"",
      employee_email:"",
      pseudo:"",
      project:"",
      employee_status:"",
      employee_wfh:'',
      department: "",
      division: "",
      campaign: "",
      section: "",
      designation: ""
      },

      isFocusedEmpStatus:"",
      selectedDesignation:"",
      employmentStatuses: [],
      employmentWfhStatuses: ['yes' , 'no'],
      departments:[],
      allDepartments: [],
      divisions: [],
      campaigns: [],
      projects: [],
      sections: [],
      designations:[],
      employmentStatusesLoading: false,
      employmentStatusesLoaded: false,
      departmentsLoading: false,
      departmentsLoaded: false,
      divisionsLoading: false,
      divisionsLoaded: false,
      campaignsLoading: false,
      campaignsLoaded: false,
      projectsLoading: false,
      projectsLoaded: false,
      sectionsLoading: false,
      sectionsLoaded: false,
      designationsLoading: false,
      designationsLoaded: false,
      searched: false,


    };
  },
  props:{
  },
  methods: {
    handleFilters(value) {
      
      //console.log(JSON.stringify(this.filters));
      this.searched = true;
      this.$emit('apply-filters', this.filters);
      // Perform any action on change
    },

    handleClearOneFilter(fileName) {
      this.filters[fileName] = "";
      const filtersHasProperty = Object.values(this.filters).filter(el => !!el).length;
      if(this.searched) {
        this.$emit('apply-filters', this.filters);
       }
      if(!filtersHasProperty) {
          this.searched = false
      }
    },

    resetAllFilters() {
      // Reset all filter values to empty strings
      Object.keys(this.filters).forEach(key => {
        this.filters[key] = "";
      });

      // Emit updated filters
      this.$emit("apply-filters", this.filters);

      // Reset search state
      this.searched = false;
    },

    async fetchEmploymentStatuses() {
            if (this.employmentStatusesLoading || this.employmentStatusesLoaded) return;
            this.employmentStatusesLoading = true;
            try {
                const response = await EmploymentStatusService.getStatuses();
                this.employmentStatuses = response?.data.map(el => ({id: el.id, text: el.status_name}));
                this.employmentStatusesLoaded = true;
            } catch (error) {
                console.error('Error fetching countries:', error);
            } finally {
                this.employmentStatusesLoading = false;
            }
        },

    async fetchDesignations() {
      if (this.designationsLoading || this.designationsLoaded) return;
      this.designationsLoading = true;
      try {
        const response = await DesignationService.getDesignations();
        this.designations = response?.data.map(el => ({id: el.id, text: el.designation_name}));
        this.designationsLoaded = true;
      } catch (error) {
        console.error('Error fetching designations:', error);
      } finally {
        this.designationsLoading = false;
      }
    },

    async fetchDivisions() {
      if (this.divisionsLoading || this.divisionsLoaded) return;
      this.divisionsLoading = true;
      try {
        const response = await DivisionService.getDivisions();
        this.divisions = response?.data.map(el => ({id: el.id, text: el.name}));
        this.divisionsLoaded = true;
      } catch (error) {
        console.error('Error fetching divisions:', error);
      } finally {
        this.divisionsLoading = false;
      }
    },

    async fetchDepartments() {
      if (this.departmentsLoading || this.departmentsLoaded) return;
      if (this.filters.division) return;
      this.departmentsLoading = true;
      try {
        const response = await DepartmentService.getDepartments();
        this.allDepartments = response?.data.map(el => ({id: el.id, text: el.name}));
        this.departments = this.allDepartments;
        this.departmentsLoaded = true;
      } catch (error) {
        console.error('Error fetching departments:', error);
      } finally {
        this.departmentsLoading = false;
      }
    },

    async fetchDepartmentsByDivision(divisionId) {
      this.departmentsLoading = true;
      try {
        const response = await DepartmentService.getDepartmentsDivisionWise(divisionId);
        this.departments = response?.data.map(el => ({id: el.id, text: el.name}));
      } catch (error) {
        console.error('Error fetching division-wise departments:', error);
      } finally {
        this.departmentsLoading = false;
      }
    },

    async fetchCampaigns() {
      if (this.campaignsLoading || this.campaignsLoaded) return;
      this.campaignsLoading = true;
      try {
        const response = await CampaignService.getCampaigns();
        this.campaigns = response?.data.map(el => ({id: el.id, text: el.campaigns}));
        this.campaignsLoaded = true;
      } catch (error) {
        console.error('Error fetching campaigns:', error);
      } finally {
        this.campaignsLoading = false;
      }
    },

    async fetchProjects() {
      if (this.projectsLoading || this.projectsLoaded) return;
      this.projectsLoading = true;
      try {
        const response = await EmployeeProjectService.fetch();
        this.projects = response?.data.map(el => ({id: el.id, text: el.project_name}));
        this.projectsLoaded = true;
      } catch (error) {
        console.error('Error fetching projects:', error);
      } finally {
        this.projectsLoading = false;
      }
    },

    async fetchSections() {
      if (this.sectionsLoading || this.sectionsLoaded) return;
      this.sectionsLoading = true;
      try {
        const response = await SectionService.getSections();
        this.sections = response?.data.map(el => ({id: el.id, text: el.section_name}));
        this.sectionsLoaded = true;
      } catch (error) {
        console.error('Error fetching sections:', error);
      } finally {
        this.sectionsLoading = false;
      }
    },

    handleClearFilters() {
      this.$emit('apply-filters', {});
      this.filters =  {
      employee_id: "",
      employee_name: "",
      first_name: "",
      last_name: "",
      employee_cnic:"",
      employee_contact:"",
      employee_email:"",
      pseudo:"",
      project:"",
      employee_status:"",
      employee_wfh:'',
      department: "",
      division: "",
      campaign: "",
      section: "",
      designation: ""};
      this.searched = false;

    }   
  },
 created() {
    this.searched = false
  },

  watch: {
    'filters.division'(newDivisionId) {
      if (newDivisionId) {
        this.fetchDepartmentsByDivision(newDivisionId);
      } else if (this.departmentsLoaded) {
        this.departments = this.allDepartments;
      } else {
        this.fetchDepartments();
      }
    }
  },

  computed: {
    isFilterApplied() {
        const filtersHasProperty = Object.values(this.filters).filter(el => !!el).length;

      return this.searched && filtersHasProperty
    }

    
  },


};
</script>

<style scoped>
.filter-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.filter-label {
  font-size: 12.5px;
  font-weight: 600;
  color: #878787;
  margin: 0 0 4px;
  margin: 0px;
  padding: 0px;
}

.filter-label-row .filter-label {
  margin: 0;
}

.filter-clear-icon {
  font-size: 10px;
  color: #8c9bb5;
  cursor: pointer;
  transition: color 0.2s ease;
}

.filter-clear-icon:hover {
  color: var(--primary-color);
}

:deep(.filter-input) {
  height: 36px;
  border-radius: 6px;
  border: 1px solid #dcdfe6;
  font-size: 12.5px;
  padding: 6px 12px;
  transition: all 0.2s ease;
}

:deep(.filter-input:focus) {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary-color) 10%, transparent);
}

:deep(.select2-container--default .select2-selection--single) {
  height: 36px !important;
  border-radius: 6px !important;
  border: 1px solid #dcdfe6 !important;
  transition: all 0.2s ease;
}

:deep(.select2-container--default .select2-selection--single .select2-selection__rendered) {
  font-size: 12.5px !important;
  line-height: 34px !important;
  padding-left: 12px !important;
  padding-right: 30px !important;
}

:deep(.select2-container--default .select2-selection--single .select2-selection__arrow) {
  height: 34px !important;
}

:deep(.select2-container--open .select2-selection--single) {
  border-color: var(--primary-color) !important;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary-color) 10%, transparent);
}

.btn-filter {
  height: 36px;
  padding: 0 14px;
  font-size: 12.5px;
  font-weight: 700;
  border-radius: 6px;
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
  color: #ffffff;
  transition: all 0.2s ease;
  cursor: pointer;
}

.btn-filter:hover {
  background-color: color-mix(in srgb, var(--primary-color) 90%, #000);
  border-color: color-mix(in srgb, var(--primary-color) 90%, #000);
  color: #ffffff;
}

.btn-reset {
  height: 36px;
  padding: 0 14px;
  font-size: 12.5px;
  font-weight: 700;
  border-radius: 6px;
  background-color: #ffffff;
  border: 1px solid #dcdfe6;
  color: #606266;
  transition: all 0.2s ease;
  cursor: pointer;
}

.btn-reset:hover {
  background-color: #f5f7fa;
  border-color: #c0c4cc;
  color: #303133;
}
</style>
